import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
import React from "react";
var __jsx = React.createElement;
const BackArrowMobileIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: "12",
    height: "10",
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.5205 5C11.5205 5.3797 11.2123 5.6875 10.8321 5.6875L2.85693 5.6875L5.81199 8.63886C6.08081 8.90735 6.08081 9.34265 5.81199 9.61114C5.54317 9.87962 5.10732 9.87962 4.8385 9.61114L0.708324 5.48614C0.439502 5.21765 0.439502 4.78235 0.708324 4.51386L4.8385 0.388864C5.10732 0.120379 5.54317 0.120379 5.81199 0.388864C6.08081 0.65735 6.08081 1.09265 5.81199 1.36114L2.85693 4.3125L10.8321 4.3125C11.2123 4.3125 11.5205 4.6203 11.5205 5Z",
    fill: color
  }));
};
export default BackArrowMobileIcon;